class ShowIntegrationType {
	static None = 0;
	static Feed = 1;
	static Playlist = 2;
	static Vignette = 3;
	static Originated = 4;
	static Simulcast = 5;
	static MusicShow = 6;
	static Split = 7;
}

export default ShowIntegrationType;